import { render, staticRenderFns } from "./PromotionsSidebar.vue?vue&type=template&id=40cdf4d4&scoped=true"
import script from "./PromotionsSidebar.vue?vue&type=script&lang=js"
export * from "./PromotionsSidebar.vue?vue&type=script&lang=js"
import style0 from "./PromotionsSidebar.vue?vue&type=style&index=0&id=40cdf4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cdf4d4",
  null
  
)

export default component.exports